function Carousel({
	items,
}) {
	return (
		<div className="carousel-wrapper">
			{items}
		</div>
	);
}

export default Carousel;
